import type { ResourceTokenAuthInfoBarRequest } from "../utils/getResourceTokenAuthInfoBarRequestKey";
import { getIndexerValueForMailboxInfo, type MailboxInfo } from "owa-client-types";
import { createStore } from "owa-satcheljs";

export type StoredResourceTokenAuthInfoBarRequest = ResourceTokenAuthInfoBarRequest & {
    requestKey: string;
};

export interface ResourceTokenAuthInfoBarState {
    request: StoredResourceTokenAuthInfoBarRequest | undefined;
}

export interface ResourceTokenAuthInfoBarStore {
    storeMap: Map<string, ResourceTokenAuthInfoBarState>;
}

const getStore = createStore<ResourceTokenAuthInfoBarStore>("resourceTokenAuthInfoBarStore", {
    storeMap: new Map(),
});

export default function getResourceTokenAuthInfoBarStore(mailboxInfo: MailboxInfo): ResourceTokenAuthInfoBarState | undefined {
    const accountKey = getIndexerValueForMailboxInfo(mailboxInfo);
    return getStore().storeMap.get(accountKey);
}

export function getResourceTokenAuthInfoBarStoreMap(): ResourceTokenAuthInfoBarStore {
    return getStore();
}
